/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { getBilder, createBild, deleteBild, buildAssetUrl } from '../services/api';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './BilderVerwaltung.css';

// FontAwesome-Bibliothek initialisieren
library.add(fas, far, fab);

function BilderVerwaltung() {
  const [bilder, setBilder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [uploadType, setUploadType] = useState('upload'); // 'upload' oder 'fontawesome'
  const [selectedFile, setSelectedFile] = useState(null);
  const [bildName, setBildName] = useState('');
  const [iconName, setIconName] = useState('');
  const [iconStyle, setIconStyle] = useState('solid');

  useEffect(() => {
    loadBilder();
  }, []);

  const loadBilder = async () => {
    try {
      setLoading(true);
      const data = await getBilder();
      setBilder(data);
    } catch (error) {
      showMessage('error', 'Fehler beim Laden der Bilder');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      if (!bildName) {
        setBildName(file.name);
      }
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (uploadType === 'upload') {
      // Datei-Upload
      if (!selectedFile) {
        showMessage('error', 'Bitte wählen Sie ein Bild aus');
        return;
      }

      const formData = new FormData();
      formData.append('image', selectedFile);
      formData.append('name', bildName);
      formData.append('type', 'upload');

      try {
        await createBild(formData);
        showMessage('success', 'Bild erfolgreich hochgeladen');
        setSelectedFile(null);
        setBildName('');
        setShowUploadForm(false);
        loadBilder();
      } catch (error) {
        showMessage('error', 'Fehler beim Hochladen des Bildes');
      }
    } else {
      // FontAwesome-Icon
      if (!iconName || !bildName) {
        showMessage('error', 'Bitte geben Sie einen Icon-Namen und einen Anzeigenamen ein');
        return;
      }

      const formData = new FormData();
      formData.append('type', 'fontawesome');
      formData.append('name', bildName);
      formData.append('iconName', iconName);
      formData.append('iconStyle', iconStyle);

      try {
        await createBild(formData);
        showMessage('success', 'FontAwesome-Icon erfolgreich hinzugefügt');
        setIconName('');
        setBildName('');
        setShowUploadForm(false);
        loadBilder();
      } catch (error) {
        showMessage('error', 'Fehler beim Hinzufügen des Icons');
      }
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Möchten Sie dieses Bild wirklich löschen?')) {
      try {
        await deleteBild(id);
        showMessage('success', 'Bild erfolgreich gelöscht');
        loadBilder();
      } catch (error) {
        showMessage('error', 'Fehler beim Löschen des Bildes');
      }
    }
  };

  const resetForm = () => {
    setSelectedFile(null);
    setBildName('');
    setIconName('');
    setIconStyle('solid');
    setUploadType('upload');
    setShowUploadForm(false);
  };

  if (loading) {
    return <div className="loading">Lade Bilder...</div>;
  }

  return (
    <div className="bilder-verwaltung">
      <div className="header">
        <h2>Bildverwaltung</h2>
        <button
          className="btn btn-primary"
          onClick={() => setShowUploadForm(!showUploadForm)}
        >
          {showUploadForm ? 'Abbrechen' : 'Neues Bild hochladen'}
        </button>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      {showUploadForm && (
        <div className="upload-form card">
          <h3>Bild hinzufügen</h3>
          <form onSubmit={handleUpload}>
            <div className="form-group">
              <label>Typ</label>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                <button
                  type="button"
                  className={`btn ${uploadType === 'upload' ? 'btn-primary' : 'btn-secondary'}`}
                  onClick={() => setUploadType('upload')}
                >
                  Datei hochladen
                </button>
                <button
                  type="button"
                  className={`btn ${uploadType === 'fontawesome' ? 'btn-primary' : 'btn-secondary'}`}
                  onClick={() => setUploadType('fontawesome')}
                >
                  FontAwesome-Icon
                </button>
              </div>
            </div>

            {uploadType === 'upload' ? (
              <>
                <div className="form-group">
                  <label>Bild auswählen</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileSelect}
                    required
                  />
                  {selectedFile && (
                    <div className="file-preview">
                      <img
                        src={URL.createObjectURL(selectedFile)}
                        alt="Vorschau"
                        style={{ maxWidth: '200px', marginTop: '10px' }}
                      />
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={bildName}
                    onChange={(e) => setBildName(e.target.value)}
                    placeholder="Name des Bildes"
                    required
                  />
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <label>Icon-Name</label>
                  <input
                    type="text"
                    value={iconName}
                    onChange={(e) => setIconName(e.target.value)}
                    placeholder="z.B. heart, star, home"
                    required
                  />
                  <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
                    Suchen Sie Icons auf <a href="https://fontawesome.com/icons" target="_blank" rel="noopener noreferrer">fontawesome.com/icons</a>
                  </small>
                  {iconName && (
                    <div style={{ marginTop: '10px', fontSize: '48px' }}>
                      <FontAwesomeIcon icon={[iconStyle === 'brands' ? 'fab' : iconStyle === 'regular' ? 'far' : 'fas', iconName]} />
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Icon-Stil</label>
                  <select value={iconStyle} onChange={(e) => setIconStyle(e.target.value)}>
                    <option value="solid">Solid (ausgefüllt)</option>
                    <option value="regular">Regular (Umriss)</option>
                    <option value="brands">Brands (Marken)</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Anzeigename</label>
                  <input
                    type="text"
                    value={bildName}
                    onChange={(e) => setBildName(e.target.value)}
                    placeholder="Name für die Auswahl"
                    required
                  />
                </div>
              </>
            )}

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {uploadType === 'upload' ? 'Hochladen' : 'Icon hinzufügen'}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={resetForm}
              >
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="bilder-grid">
        {bilder.length === 0 ? (
          <p className="no-data">Keine Bilder vorhanden</p>
        ) : (
          bilder.filter(bild => bild).map((bild) => (
            <div key={bild.id} className="bild-item card">
              <div className="bild-preview">
                {bild.type === 'fontawesome' ? (
                  <div style={{ fontSize: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <FontAwesomeIcon
                      icon={[
                        bild.iconStyle === 'brands' ? 'fab' : bild.iconStyle === 'regular' ? 'far' : 'fas',
                        bild.iconName
                      ]}
                    />
                  </div>
                ) : (
                  <img
                    src={buildAssetUrl(bild.path)}
                    alt={bild.name}
                  />
                )}
              </div>
              <div className="bild-info">
                <h4>{bild.name}</h4>
                <p className="bild-date">
                  {bild.type === 'fontawesome' ? 'FontAwesome-Icon' : 'Bild'} · {new Date(bild.erstellt).toLocaleDateString('de-DE')}
                </p>
              </div>
              <div className="bild-actions">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(bild.id)}
                >
                  Löschen
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default BilderVerwaltung;
